import { useEffect, useState } from "react";
import axios from "axios";

const AllBlogs = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(
          `https://blogs.entdelhi.com/wp-json/wp/v2/posts?_embed&per_page=100`
        );
        setPosts(response.data);
      } catch (err) {
        setError("Failed to fetch posts");
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  return (
    <div>
      <style>{`
        .slider-container {
          max-width: 1200px;
          margin: 40px auto;
          padding: 20px;
          font-family: Arial, sans-serif;
        }

        .news-heading {
          text-align: center;
          font-size: 36px;
  color: #505050;
  font-weight: 600;
          margin-bottom: 30px;
        }

        .slider {
          display: flex;
          overflow-x: auto;
          scroll-behavior: smooth;
          gap: 20px;
          padding-bottom: 10px;
        }

        .slider::-webkit-scrollbar {
          height: 8px;
        }

        .slider::-webkit-scrollbar-thumb {
          background-color: #007bff;
          border-radius: 4px;
        }

        .blog-card {
          flex: 0 0 300px;
          background: white;
          padding: 15px;
          border-radius: 8px;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
          cursor: pointer;
          transition: transform 0.3s ease;
        }

        .blog-card:hover {
          transform: translateY(-5px);
        }

        .blog-card img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          border-radius: 5px;
        }

        .blog-card h2 {
          font-size: 20px;
          color: #333;
          margin: 10px 0;
        }

        .paragraphblog {
          display: none !important;
        }
      `}</style>

      <div className="slider-container">
        <h2 className="news-heading">ENT News </h2>

        {loading && <p>Loading...</p>}
        {error && <p>Error: {error}</p>}

        <div className="slider">
          {posts.map((post) => {
            const imageUrl = post._embedded?.["wp:featuredmedia"]?.[0]?.source_url;
            return (
              <div
                key={post.id}
                className="blog-card"
                onClick={() => window.location.href = `/blog/${post.slug}`}
              >
                {imageUrl && <img src={imageUrl} alt={post.title.rendered} />}
                <h2 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AllBlogs;
